import { Services } from '@sigma-frontend-libs/commons'

import { components } from '@/utils'

import flag from '@/components/flag'

function renderItem(h, item) {
  return h(
    'div',
    {
      class: `${Services['country-regions']}-country-code`
    },
    [
      h(
        flag,
        {
          props: {
            value: item.value,
            size: 16,
            tooltip: false
          }
        }
      ),
      h('span', { class: `${Services['country-regions']}-country-code__code` }, [ item.value ]),
      h('span', { class: `${Services['country-regions']}-country-code__name` }, [ item.country ])
    ]
  )
}

export default function(h) {
  return h(
    components.select,
    {
      props: {
        value: this.value,
        label: this.getTranslate(`${Services['country-regions']}.labels.countryCode`),
        items: this.items,
        picks: [ 'country' ],
        mask: this.inputMask.mask,
        maskOptions: this.inputMask.maskOptions,
        required: this.required,
        setRequiredOnMounted: false,
        error: this.error,
        dense: true,
        clearable: !this.required,
        details: false,
        combobox: true,
        setOnBlur: true
      },
      scopedSlots: {
        item: ({ item }) => {
          return renderItem.call(this, h, item)
        }
      },
      on: {
        input: event => {
          this.$emit('input', event)
        }
      }
    }
  )
}
